// extracted by mini-css-extract-plugin
export default {"menu-item":"Menu_menu-item__ilG0N","active":"Menu_active__ZPUMS","icon":"Menu_icon__Ugzgk","title":"Menu_title__In4vm"};